import { apiClient } from './baseClient';
import companyClient from './company';

// Re-export the base client for direct usage
export { apiClient };

// Export typed API clients
export const api = {
  // Base methods (get, post, put, patch, delete)
  get: apiClient.get.bind(apiClient),
  post: apiClient.post.bind(apiClient),
  put: apiClient.put.bind(apiClient),
  patch: apiClient.patch.bind(apiClient),
  delete: apiClient.delete.bind(apiClient),

  // Module-specific clients
  company: companyClient,
  // Register other clients here... (cloudagents, endpoints, webapps)
};
